var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.option)?_c('v-chart',{style:({height:_vm.height+'px'}),attrs:{"option":_vm.option,"theme":_vm.theme,"update-options":_vm.updateOptions},on:{"click":_vm.handleClick}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }